import Vue from "vue";
import moment from 'moment'
import validatePop from "@/plugins/validatePop.js";
const vm = new Vue();

export const getListOrderCodForExcel = async ( search , totalPage ) => {
    return new Promise((resolve, reject) => {
        let ExcelTask = []
        let page = 1;
        for( let i = 0 ; i < totalPage; i++ ){
            ExcelTask.push( vm.$http
                .post(
                    vm.$API_URL + "/shop/order/cod",
                    {
                        ...search,
                        page: page++
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token"),
                        },
                    }
                )
            ) 
        }
        Promise.all(ExcelTask).then( (resData) => {
            let dataExcel = [];
            resData.forEach( data => {
                dataExcel.push(...data.data.data.orders)
            })  
            resolve(dataExcel)
        })
    })
}

export const getListOrderDropoffForExcelS3 = async (filters) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .get( vm.$API_URL + `/service/dropoff/orders/excel`, {
                headers: {
                    Token: localStorage.getItem("access_token")
                },
                params: {
                    date_start:  moment( filters.startDate ).format( "YYYY-MM-DD" ),
                    date_end: moment(filters.endDate).format( "YYYY-MM-DD" ),
                    key: filters.key,
                    status: filters.status,
                    shop_id: filters.selectedShop,
                }
            })
            .then( async (res) => {
                if (!res.data.status) {   
                    reject(res.data.error);
                }
                resolve(res.data);
            }).catch((error) => {
                reject(error);
            });
    });
}

export const getReportShippops = async (bodyObject) => {
    return new Promise((resolve, reject) => {
        vm.$http
        .post( vm.$API_URL + "/admin/shippops",
            {
                ...( ( bodyObject.searchType == 'date' ) ? {  
                    start: bodyObject.startDate , 
                    end: bodyObject.endDate, 
                    courierKey: bodyObject.courierKey, 
                } : { 
                    start: false , 
                    end: false , 
                    trackingCode: bodyObject.trackingCode 
                } ),
                dateType: bodyObject.dateType,
                shop: bodyObject.shop,
                page: bodyObject.current_page,
                ...( bodyObject.is_excel ) ? { is_excel: bodyObject.is_excel } : {}
            },
            {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }).then(res => {
                let data = res.data.data;
                let checkError = validatePop(res);
                if (!checkError.status) {
                    if( checkError.notices == "token is expired"){
                        vm.$router.push("/logout")  
                    }
                    reject(checkError.msg);
                }

                resolve(data);
            }).catch((error) => {
                reject(error);
            });
    });
}

export const getListOrderDropoffDailyExcel = async (filters) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .get( vm.$API_URL + `/service/dropoff/report/daily`, {
                headers: {
                    Token: localStorage.getItem("access_token")
                },
                params: {
                    date_start:  moment( filters.startDate ).format( "YYYY-MM-DD" ),
                    date_end: moment(filters.endDate).format( "YYYY-MM-DD" ),
                    key: filters.key,
                    status: filters.status,
                }
            })
            .then( async (res) => {
                if (!res.data.status) {   
                    reject(res.data.error);
                }
                resolve(res.data);
            }).catch((error) => {
                reject(error);
            });
    });
}